import { GlobalOutlined } from '@ant-design/icons';
import { useIntl, useModel } from '@umijs/max';
import { Segmented, Space, Tooltip } from 'antd';
import type { TimezoneMode } from '@/utils/timezone';

export const SelectTimezone: React.FC = () => {
  const intl = useIntl();
  const { mode, setMode } = useModel('timezone');

  return (
    <Tooltip title={intl.formatMessage({ id: 'crm.timezone.tooltip' })}>
      <Space size={4}>
        <GlobalOutlined style={{ color: 'rgba(0, 0, 0, 0.45)' }} />
        <Segmented
          size="small"
          value={mode}
          onChange={(value) => setMode(value as TimezoneMode)}
          options={[
            {
              label: intl.formatMessage({ id: 'crm.timezone.local' }),
              value: 'local',
            },
            {
              label: intl.formatMessage({ id: 'crm.timezone.utc' }),
              value: 'utc',
            },
          ]}
        />
      </Space>
    </Tooltip>
  );
};
